'use strict';

console.log('app.js 1.2');

var app = {};

;(function ($) {
    var $doc = $(document);

    /** [1] */
    $.readyFn = {
        list: [],
        register: function (fn) {
            //console.log('Module Registered');

            $.readyFn.list.push(fn);
        },
        execute: function () {
            //console.log('Modules Executing');

            for (var i = 0; i < $.readyFn.list.length; i++) {
                try {
                    $.readyFn.list[i].apply(document, [$]);
                } catch (e) {
                    throw e;
                }
            }
        }
    };

    /** [2] */
    app = {
        initPopinConnexion: function () {

            if (window.matchMedia("(max-width: 1024px)").matches) {
                if (!$('body').hasClass('logged-in')) {
                    $('.connexion_link').click(function () {
                        $('body').addClass('popin-choice-open');
                        $('#popin-choice').addClass('activate');
                        //return false;
                    });
                } else {
                    //return false;
                }
            } else {
                if (!$('body').hasClass('logged-in')) {
                    $('.connexion_link').click(function () {
                        $('body').addClass('popin-choice-open');
                        $('#popin-choice').addClass('activate');
                        return false;
                    });
                } else {
                    return false;
                }
            }

            $(document).on('click', function closeMenu(e) {
                if ($('#popin-choice').has(e.target).length === 0) {
                    $('body .voile.visible').removeClass('visible');
                    $('body').removeClass('popin-choice-open');
                    $('#popin-choice').removeClass('activate');
                } else {
                    $(document).one('click', closeMenu);
                }
            });
        },
        initCarousel: function () {
            // console.log('Module Executed: Carousel');

            /*
            SLiders polymorphe
            */
            // Bloc 2 col :: slider ou image à gauche / texte ou accordéon à droite
            $(".slide_image__texte_cta_accordeon .wrapper_slider").addClass('owl-carousel');
            $(".slide_image__texte_cta_accordeon .wrapper_slider").owlCarousel({
                loop: true,
                margin: 0,
                items: 1,
                nav: true,
                autoplay: false,
                dots: false,
            });
            // custom nav
            $('.wrapper_nav_slider a.left').click(function(){
              $('.slide_image__texte_cta_accordeon .owl-prev').trigger('click');
              return false;
            });
            $('.wrapper_nav_slider a.right').click(function(){
              $('.slide_image__texte_cta_accordeon .owl-next').trigger('click');
              return false;
            });

            // Bloc slider avec textes à gauche et gros visuel à droite
            // uniquement si slide.length > 1
            // POUR CHAQUE STRATE bloc_poly.gros_slider
            $(".bloc_poly.gros_slider .wrapper_slider").each(function(){
              var nbr_slide = $(this).find('.slide').length;
              if( nbr_slide > 1){
                $(this).addClass('owl-carousel');
                $(this).owlCarousel({
                    loop: true,
                    margin: 0,
                    items: 1,
                    autoplay: false,
                    nav: true,
                    dots: false,
                });
                // custom nav
                $('.bloc_poly.gros_slider .wrapper_nav_slider a.left').click(function(){
                  $('.bloc_poly.gros_slider .owl-prev').trigger('click');
                  return false;
                });
                $('.bloc_poly.gros_slider .wrapper_nav_slider a.right').click(function(){
                  $('.bloc_poly.gros_slider .owl-next').trigger('click');
                  return false;
                });
              }
            });





            // SLIDER HOME
            $(".home .slider_home").addClass('owl-carousel');
            $(".home .slider_home.owl-carousel").owlCarousel({
                loop: true,
                margin: 0,
                items: 1,
                nav: true,
                autoplay:true,
                autoplayTimeout: 7500,
                autoplaySpeed: 1200,
                responsiveClass: false,
                responsive: {
                    0: {
                        dots: true,
                    },
                    480: {
                        dots: false,
                    }
                }
            });

            var sliderHomeButtons = $('.home .slider_home.owl-carousel > .owl-nav').clone();
            $('.home .wrapper_slider_home .slider_home .owl-stage-outer').append("<div class='slider_home_nav'><div class='wrapper size_max_width'></div>");
            sliderHomeButtons.appendTo($('.home .wrapper_slider_home .slider_home .owl-stage-outer .slider_home_nav .wrapper'));

            var sliderHomeOwlPrevButton = $('.home .slider_home.owl-carousel > .owl-nav button.owl-prev'),
                sliderHomeOwlNextButton = $('.home .slider_home.owl-carousel > .owl-nav button.owl-next'),
                sliderHomeCustomOwlPrevButton = $('.home .wrapper_slider_home .slider_home .owl-stage-outer .slider_home_nav button.owl-prev'),
                sliderHomeCustomOwlNextButton = $('.home .wrapper_slider_home .slider_home .owl-stage-outer .slider_home_nav button.owl-next');

            $('.home .slider_home.owl-carousel').on('changed.owl.carousel', function (event) {
                if (sliderHomeOwlPrevButton.hasClass('disabled')) {
                    sliderHomeCustomOwlPrevButton.addClass('disabled');
                } else {
                    sliderHomeCustomOwlPrevButton.removeClass('disabled');
                }
                if (sliderHomeOwlNextButton.hasClass('disabled')) {
                    sliderHomeCustomOwlNextButton.addClass('disabled');
                } else {
                    sliderHomeCustomOwlNextButton.removeClass('disabled');
                }
            });

            sliderHomeCustomOwlPrevButton.click(function () {
                sliderHomeOwlPrevButton.trigger('click');
            });
            sliderHomeCustomOwlNextButton.click(function () {
                sliderHomeOwlNextButton.trigger('click');
            });

            // SLIDER HOME NOS PRODUITS
            $(".home .nos_produits .wrapper .slider").addClass('owl-carousel');
            $(".home .nos_produits .wrapper .slider.owl-carousel").owlCarousel({
                loop: false,
                margin: 0,
                items: 5,
                nav: true,
                dots: false,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1,
                        margin: 10,
                        autoWidth: true,
                        nav: false,
                        dots: true,
                    },
                    520: {
                        items: 3,
                        nav: false,
                        dots: true,
                        autoWidth: true,
                        margin: 10,
                    },
                    900: {
                        items: 3,
                        nav: false,
                        autoWidth: true,
                        margin: 10,
                    },
                    1100: {
                        items: 4,
                    },
                    1300: {
                        items: 5
                    }
                }
            });

            // SLIDER HOME MINI SLIDER
            $(".home .home-mini-slider .slider_wrapper").addClass('owl-carousel');
            $(".home .home-mini-slider .slider_wrapper.owl-carousel").owlCarousel({
                loop: false,
                margin: 0,
                items: 1,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1,
                        dots: true,
                        nav: false,
                    },
                    520: {
                        dots: false,
                        nav: true,
                    }
                }
            });

            // SLIDER PROFIL SLIDER BIG
            $(".single-profil .module_big_slider .slider_big").addClass('owl-carousel');
            $(".single-profil .module_big_slider .slider_big.owl-carousel").owlCarousel({
                loop: false,
                margin: 0,
                items: 1,
                responsiveClass: true,
                responsive: {
                    0: {
                        dots: true,
                        nav: false,
                    },
                    769: {
                        dots: false,
                        nav: true,
                    }
                }
            });
            $(".single-profil .module_big_slider").each(function (index) {
                //var sliderBigNav = $(this).find('.slider_big.owl-carousel > .owl-nav').clone();
                //$(this).find('.col_texte .bottom').append( "<div class='big_slider_nav'></div>" );
                //sliderBigNav.appendTo($(this).find('.col_texte .big_slider_nav'));

                var sliderBigOwlPrevButton = $(this).find('.slider_big.owl-carousel > .owl-nav button.owl-prev'),
                    sliderBigOwlNextButton = $(this).find('.slider_big.owl-carousel > .owl-nav button.owl-next'),
                    sliderBigCustomOwlPrevButton = $(this).find('.col_texte .big_slider_nav button.owl-prev'),
                    sliderBigCustomOwlNextButton = $(this).find('.col_texte .big_slider_nav button.owl-next');

                $(this).find('.slider_big.owl-carousel').on('changed.owl.carousel', function (event) {
                    if (sliderBigOwlPrevButton.hasClass('disabled')) {
                        sliderBigCustomOwlPrevButton.addClass('disabled');
                    } else {
                        sliderBigCustomOwlPrevButton.removeClass('disabled');
                    }
                    if (sliderBigOwlNextButton.hasClass('disabled')) {
                        sliderBigCustomOwlNextButton.addClass('disabled');
                    } else {
                        sliderBigCustomOwlNextButton.removeClass('disabled');
                    }
                });

                sliderBigCustomOwlPrevButton.click(function () {
                    sliderBigOwlPrevButton.trigger('click');
                });
                sliderBigCustomOwlNextButton.click(function () {
                    sliderBigOwlNextButton.trigger('click');
                });
            });

            // SLIDER PROFIL SLIDER LIST
            $(".single-profil .module_list_slider .slider_list").addClass('owl-carousel');
            $(".single-profil .module_list_slider .slider_list.owl-carousel").owlCarousel({
                loop: false,
                margin: 0,
                items: 1,
                nav: true,
                dots: false,
                responsiveClass: true,
                responsive: {
                    0: {
                        dots: true,
                        nav: false,
                    },
                    769: {
                        dots: false,
                        nav: true,
                    }
                }
            });
            $(".single-profil .module_list_slider").each(function (index) {
                // var sliderListNav = $(this).find('.slider_list.owl-carousel > .owl-nav').clone();
                // $(this).find('.col_texte .bottom').append( "<div class='list_slider_nav'></div>" );
                // sliderListNav.appendTo($(this).find('.col_texte .list_slider_nav'));

                var sliderListOwlPrevButton = $(this).find('.slider_list.owl-carousel > .owl-nav button.owl-prev'),
                    sliderListOwlNextButton = $(this).find('.slider_list.owl-carousel > .owl-nav button.owl-next'),
                    sliderListCustomOwlPrevButton = $(this).find('.col_texte .list_slider_nav button.owl-prev'),
                    sliderListCustomOwlNextButton = $(this).find('.col_texte .list_slider_nav button.owl-next');

                $(this).find('.slider_list.owl-carousel').on('changed.owl.carousel', function (event) {
                    if (sliderListOwlPrevButton.hasClass('disabled')) {
                        sliderListCustomOwlPrevButton.addClass('disabled');
                    } else {
                        sliderListCustomOwlPrevButton.removeClass('disabled');
                    }
                    if (sliderListOwlNextButton.hasClass('disabled')) {
                        sliderListCustomOwlNextButton.addClass('disabled');
                    } else {
                        sliderListCustomOwlNextButton.removeClass('disabled');
                    }
                });

                sliderListCustomOwlPrevButton.click(function () {
                    sliderListOwlPrevButton.trigger('click');
                });
                sliderListCustomOwlNextButton.click(function () {
                    sliderListOwlNextButton.trigger('click');
                });
            });

            // SLIDER A PROPOS SLIDER
            $(".apropos_slider .wrapper_slider").addClass('owl-carousel');
            $(".apropos_slider .wrapper_slider.owl-carousel").owlCarousel({
                loop: false,
                margin: 0,
                items: 1,
                nav: true,
                dots: false,
                autoHeight: true
            });
            var sliderAproposButtons = $('.apropos_slider .wrapper_slider.owl-carousel > .owl-nav').clone();
            $('.apropos_slider .slider_nav').append("<div class='slider_sub_nav'></div>");
            sliderAproposButtons.appendTo($('.apropos_slider .slider_nav .slider_sub_nav'));

            var sliderAproposOwlPrevButton = $('.apropos_slider .wrapper_slider.owl-carousel > .owl-nav button.owl-prev'),
                sliderAproposOwlNextButton = $('.apropos_slider .wrapper_slider.owl-carousel > .owl-nav button.owl-next'),
                sliderAproposCustomOwlPrevButton = $('.apropos_slider .slider_nav .slider_sub_nav button.owl-prev'),
                sliderAproposCustomOwlNextButton = $('.apropos_slider .slider_nav .slider_sub_nav button.owl-next');

            $('.apropos_slider .wrapper_slider.owl-carousel').on('changed.owl.carousel', function (event) {
                if (sliderAproposOwlPrevButton.hasClass('disabled')) {
                    sliderAproposCustomOwlPrevButton.addClass('disabled');
                } else {
                    sliderAproposCustomOwlPrevButton.removeClass('disabled');
                }
                if (sliderAproposOwlNextButton.hasClass('disabled')) {
                    sliderAproposCustomOwlNextButton.addClass('disabled');
                } else {
                    sliderAproposCustomOwlNextButton.removeClass('disabled');
                }
            });

            var currentSlideHtml = $('.page-template-apropos .apropos_slider .slider_nav .pagination .current');
            var currentSlide = 1;

            sliderAproposCustomOwlPrevButton.click(function () {
                sliderAproposOwlPrevButton.trigger('click');
                currentSlide--;
                currentSlideHtml.text(currentSlide);
            });
            sliderAproposCustomOwlNextButton.click(function () {
                sliderAproposOwlNextButton.trigger('click');
                currentSlide++;
                currentSlideHtml.text(currentSlide);
            });

            // SLIDER INTRODUCTION CATALOGUE
            $(".woocommerce-page .slider_archive_product").addClass('owl-carousel');
            /**/
            $(".woocommerce-page .slider_archive_product.owl-carousel").owlCarousel({
                loop: true,
                margin: 0,
                items: 1,
                nav: false,
                dots: false,
                autoplay: false,
                autoplayTimeout: 6000,
                autoplaySpeed: 1200
            });
            /*
            var sliderArchiveProductButtons = $('.woocommerce-page .slider_archive_product.owl-carousel > .owl-nav').clone();
            $('.woocommerce-page .wrapper .slider_archive_product .owl-stage-outer').append("<div class='slider_archive_product_nav'><div class='size_max_width'></div></div>");
            sliderArchiveProductButtons.appendTo($('.woocommerce-page .wrapper .slider_archive_product .owl-stage-outer .slider_archive_product_nav .size_max_width'));
            */
            /*
            var sliderArchiveProductOwlPrevButton = $('.woocommerce-page .slider_archive_product.owl-carousel > .owl-nav button.owl-prev'),
                sliderArchiveProductOwlNextButton = $('.woocommerce-page .slider_archive_product.owl-carousel > .owl-nav button.owl-next'),
                sliderArchiveProductCustomOwlPrevButton = $('.woocommerce-page .wrapper .slider_archive_product .owl-stage-outer .slider_archive_product_nav button.owl-prev'),
                sliderArchiveProductCustomOwlNextButton = $('.woocommerce-page .wrapper .slider_archive_product .owl-stage-outer .slider_archive_product_nav button.owl-next');
            */
            /*
            $('.woocommerce-page .slider_archive_product.owl-carousel').on('changed.owl.carousel', function (event) {
                if (sliderArchiveProductOwlPrevButton.hasClass('disabled')) {
                    sliderArchiveProductCustomOwlPrevButton.addClass('disabled');
                } else {
                    sliderArchiveProductCustomOwlPrevButton.removeClass('disabled');
                }
                if (sliderArchiveProductOwlNextButton.hasClass('disabled')) {
                    sliderArchiveProductCustomOwlNextButton.addClass('disabled');
                } else {
                    sliderArchiveProductCustomOwlNextButton.removeClass('disabled');
                }
            });
            */

            $('.introduction .wrapper .wrapper_nav .arrow.left').click(function () {
              $('.slider_archive_product .owl-nav .owl-prev').trigger('click');
              return false;
            });
            $('.introduction .wrapper .wrapper_nav .arrow.right').click(function () {
              $('.slider_archive_product .owl-nav .owl-next').trigger('click');
              return false;
            });





            // SLIDER RECRUTEMENT
            $(".page-template-recrutement .slider_home").addClass('owl-carousel');
            $(".page-template-recrutement .slider_home.owl-carousel").owlCarousel({
                loop: true,
                margin: 0,
                items: 1,
                nav: true,
                autoplay: false,
                autoplayTimeout: 6000,
                autoplaySpeed: 1200,
                responsiveClass: false,
                responsive: {
                    0: {
                        dots: true,
                    },
                    480: {
                        dots: false,
                    }
                }
            });
            var sliderRecrutementButtons = $('.page-template-recrutement .slider_home.owl-carousel > .owl-nav').clone();
            $('.page-template-recrutement .wrapper_slider_home .slider_home .owl-stage-outer').append("<div class='slider_home_nav'><div class='wrapper size_max_width'></div>");
            sliderRecrutementButtons.appendTo($('.page-template-recrutement .wrapper_slider_home .slider_home .owl-stage-outer .slider_home_nav .wrapper'));

            var sliderRecrutementOwlPrevButton = $('.page-template-recrutement .slider_home.owl-carousel > .owl-nav button.owl-prev'),
                sliderRecrutementOwlNextButton = $('.page-template-recrutement .slider_home.owl-carousel > .owl-nav button.owl-next'),
                sliderRecrutementCustomOwlPrevButton = $('.page-template-recrutement .wrapper_slider_home .slider_home .owl-stage-outer .slider_home_nav button.owl-prev'),
                sliderRecrutementCustomOwlNextButton = $('.page-template-recrutement .wrapper_slider_home .slider_home .owl-stage-outer .slider_home_nav button.owl-next');

            $('.page-template-recrutement .slider_home.owl-carousel').on('changed.owl.carousel', function (event) {
                if (sliderRecrutementOwlPrevButton.hasClass('disabled')) {
                    sliderRecrutementCustomOwlPrevButton.addClass('disabled');
                } else {
                    sliderRecrutementCustomOwlPrevButton.removeClass('disabled');
                }
                if (sliderRecrutementOwlNextButton.hasClass('disabled')) {
                    sliderRecrutementCustomOwlNextButton.addClass('disabled');
                } else {
                    sliderRecrutementCustomOwlNextButton.removeClass('disabled');
                }
            });

            sliderRecrutementCustomOwlPrevButton.click(function () {
                sliderRecrutementOwlPrevButton.trigger('click');
            });
            sliderRecrutementCustomOwlNextButton.click(function () {
                sliderRecrutementOwlNextButton.trigger('click');
            });


            // Slider espace presse => mobile only
            if (window.matchMedia("(max-width: 768px)").matches) {
                $(".article-presse-first-push .wrapper.size_max_width").addClass('owl-carousel');
                $(".article-presse-first-push .wrapper.size_max_width").owlCarousel({
                    loop: true,
                    margin: 0,
                    items: 1,
                    nav: false,
                    dots: true,
                    autoplay: false
                });

            }


        },
        initFiltersSticky: function () {

            if ($('body').hasClass('post-type-archive') && $('.filtres').length) {
                // STICKY FILTERS
                var scroll = $(window).scrollTop(),
                    filtersNav = $('section.filtres'),
                    filtersNavTopPos = filtersNav.offset().top;

                if ($(window).width() > 1024) {
                    var navHeight = $('.menus_top').outerHeight();

                    $(window).scroll(function (event) {
                        scroll = $(window).scrollTop();
                        if ((scroll + navHeight) >= filtersNavTopPos) {
                            filtersNav.addClass('stickynav');
                            filtersNav.css('top', navHeight + 'px');
                            $('.produits_liste').css('padding-top', filtersNav.outerHeight() + 'px');
                        } else {
                            filtersNav.removeClass('stickynav');
                            filtersNav.css('top', 0);
                            $('.produits_liste').css('padding-top', 0);
                        }
                    });
                } else {

                }
            }
        },
        initMenuTopScroll: function () {
            $(window).scroll(function (event) {

                scroll = $(window).scrollTop();

                if (scroll > 500) {
                    $('.menus_top').addClass('scrolled');
                    $('.menus_top').removeClass('sticky');
                    $('.menus_top').removeClass('position-initial');
                } else {
                    $('.menus_top').removeClass('scrolled');
                    $('.menus_top').addClass('sticky');
                    setTimeout(function(){ $('.menus_top').addClass('position-initial'); }, 200);
                }
            });
        },
        initStickyTimeline: function () {
            $(window).scroll(function (event) {
                var hauteurHeaderOther = $('.header-histoire').height() - 100;
                if (scroll > hauteurHeaderOther) {
                    $(".page-template-histoire section.strate-01 ul.links-anchor").addClass("scrolled");
                    $(".page-template-histoire section.strate-01").addClass("links-anchor-scrolled");
                } else {
                    $(".page-template-histoire section.strate-01 ul.links-anchor").removeClass("scrolled");
                    $(".page-template-histoire section.strate-01").removeClass("links-anchor-scrolled");

                }
            });
        },
        initVideoPlayer: function () {
            //console.log('Module Executed: Video Player');


            $('.col_image .video').click(function (e) {
                $(this).addClass('played');
                if ($(this).find('played').length) {

                } else {
                    $(this).addClass('played');
                    $(this).find('iframe')[0].src += "&autoplay=1";
                }
                //$(this).find('iframe')[0].src += "&autoplay=1";
                //e.preventDefault();
            });
        },
        initPlayVideoEmbed: function () {
            // console.log('Module Executed: Play Video Embed');

            $('a.video').click(function (event) {
                event.preventDefault();
                $('body').addClass('stop-overflow');

                var video_id = "."+$(this).data()['video'];
                var video = $(this).find('.wrapper_iframe_video iframe').clone();
                $('#popin_video').find('.video_embed').append(video);
                $('#popin_video').addClass('activate');
                $('#popin_video').find('.video_embed iframe')[0].src += "&autoplay=1";

                return false;
            });

            $('#popin_video .close_video').click(function () {
                $('body').removeClass('stop-overflow');
                $('#popin_video').removeClass('activate');
                // pas sur de savoir réelllement à quoi ça sert... sécurité peut-être ?
                $('#popin_video').find('iframe').attr('src', $('#popin_video').find('iframe').attr('src').replace('&autoplay=1', ''));
                $('#popin_video').find('.video_embed').empty();

                return false;
            });

        },
        initBurgerMenu: function () {
            // console.log('Module Executed: Burger Menu');

            // BURGER MENU
            // OUVERTURE/FERMETURE
            // ouverture et fermeture du burger menu au clic sur l'icône
            $('.header_site .burger-head .burger-icon').click(function () {
                if ($('.menus_top').hasClass('level1')) {
                    $('.menus_top').removeClass('active');
                    $('.menus_top').removeClass('level1');
                    $('.menus_top').removeClass('level2');
                    $('.header_site .menus_top .item_menu_level1 .sub-menu').removeClass('active');
                    $('.header_site .burger-icon').removeClass('opened');
                    $('body').removeClass('stop-overflow');

                } else {
                    $('.menus_top').addClass('active');
                    $('.menus_top').addClass('level1');
                    $('.header_site .burger-icon').addClass('opened');
                    $('body').addClass('stop-overflow');
                }
                return false;
            });



            // déplacement de la popin de search dans le menu burger
            var popinSearch = $('.popin_search_header').detach();
            if (window.matchMedia("(min-width: 1024px)").matches) {
                $('.header_site .menus_top').prepend(popinSearch);
            } else {
                $('.header_site .menus_top .menu_top_main').prepend(popinSearch);
            }


            // SUBMENUS HEADING
            // creation d'en-tête de titre des sous menus
            $('.header_site .menus_top .menu-principal .menu-item-has-children .sub-menu').each(function (index) {
                var currentItem = $(this).parent().find('>a').text();
                $(this).prepend('<li class="sub-menu-head">' + currentItem + '</li>');
            });
        },
        initAnchor: function () {
            // console.log('Module Executed: Anchor');

            var lastId,
                topMenu = $(".page-template-histoire section.strate-01 ul.links-anchor"),
                topMenuHeight = topMenu.outerHeight() + 80,
                // All list items
                menuItems = topMenu.find("a"),
                // Anchors corresponding to menu items
                scrollItems = menuItems.map(function () {
                    var item = $($(this).attr("href"));
                    if (item.length) {
                        return item;
                    }
                });

            menuItems.click(function (e) {
                var href = $(this).attr("href"),
                    offsetTop = href === "#" ? 0 : $(href).offset().top;
                $('html, body').animate({
                    scrollTop: offsetTop
                }, 600);
                return false;
            });

            $(window).scroll(function () {
                // Get container scroll position
                var fromTop = $(this).scrollTop() + topMenuHeight;

                // Get id of current scroll item
                var cur = scrollItems.map(function () {
                    if ($(this).offset().top < fromTop)
                        return this;
                });
                // Get the id of the current element
                cur = cur[cur.length - 1];
                var id = cur && cur.length ? cur[0].id : "";

                if (lastId !== id) {
                    lastId = id;
                    // Set/remove active class
                    menuItems
                        .parent().removeClass("active")
                        .end().filter("[href='#" + id + "']").parent().addClass("active")
                }
            });

            // SMOOTH SCROLL

            $('a.scroll-it, a.link-anchor').click(function () {
                if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                    var target = $(this.hash);
                    target = target.length ? target : $('#');
                    if (target.length) {
                        $('html, body').animate({
                            scrollTop: target.offset().top - 150
                        }, 350);
                        return false;
                    }
                }
            });
        }
        ,
        initSelect: function () {
            //console.log('Module Executed: Select');

            // A priori, obsolète...
            $('select[name="filter-blog"]').on('change', function () {
                // location.href = $(this).val();
                if($(this).attr('id')!='filtre_actualites'){
                  alert('A VERIFIER DANS app.js => obsolète ou pas ?');
                }
            });

            $('select[name="filter-type-contrat"],select[name="filter-zone-geo"]').on('change', function () {
                $(this).val() != "all" ? $(this).parent().find('span.text').hide() : $(this).parent().find('span.text').show();
                var filters = {};
                $('select[name="filter-type-contrat"]').val() != "all" ? filters.type = $('select[name="filter-type-contrat"]').val() : '';
                $('select[name="filter-zone-geo"]').val() != "all" ? filters.zone = $('select[name="filter-zone-geo"]').val() : '';
                app.filterPost(filters);
            });


        },
        filterPost: function (filters) {
            $('.offres.list .offre').hide();
            $('.offres.list .no-results').hide();
            $('.offres.list .offre').filter(function () {
                var search = "";
                $.each(filters, function (key, value) {
                    search += '[data-' + key + '*="' + value + '"]';
                });
                if (search && !$(this).is(search)) return false;
                return true;
            }).show();

            if (!$('.offres.list .offre:visible').length) {
                $('.offres.list .no-results').show();
            }
            $('body, html').animate({scrollTop: $('.offres.list').offset().top - $('.menus_top').outerHeight()});
        }
        ,
        initBugIE: function () {
            //console.log('Module Executed: Bug IE');

            function GetIEVersion() {
                var sAgent = window.navigator.userAgent;
                var Idx = sAgent.indexOf("MSIE");

                // If IE, return version number.
                if (Idx > 0)
                    return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));

                // If IE 11 then look for Updated user agent string.
                else if (!!navigator.userAgent.match(/Trident\/7\./))
                    return 11;

                else
                    return 0; //It is not IE
            }

            if (GetIEVersion() > 0) {
                $('body').addClass('ie');

                //MODERNIZR IE & EDGE
                if (!Modernizr.objectfit) {
                    $('.single-profil .module_list_slider .wrapper .col.col_slider .slider_list .slide .background, .single-profil .module_texte_image .wrapper .col.col_image .image, .single-profil .wrapper_header_profil .header_profil .slide .images_content .foreground, .module_double_case .wrapper .case .image_de_fond, .home .home-mini-slider .wrapper .col.col_droite .slider_wrapper .img_wrapper, .introduction .wrapper .slider_archive_product .slide .images_content .background, .woocommerce ul.products li.product a .imagewrapper, .actualites .wrapper_image a, .actualites_home .wrapper_image, .page-template-actualites .top .image, .apropos_slider .wrapper_image, .module_double_case.little .image_de_fond, .module_big_slider .background').each(function () {
                        var $container = $(this),
                            imgUrl = $container.find('img').prop('src');
                        if (imgUrl) {
                            $container.find('img').css('display', 'none');
                            $container
                                .css('backgroundImage', 'url(' + imgUrl + ')')
                                .addClass('compat-object-fit');
                        }
                    });
                }
            }
        },
        initTabs: function () {
            console.log('Module Executed: initTabs');
            // exemple
            $('.selecteur_A_DEFINIR').tabs({
              active: 0
            });
        },
        initAccordion: function(){
          // console.log('Module Executed: initAccordion');
          // ACF poly => Bloc 2 col :: slider ou image à gauche / texte ou accordéon à droite
          $(".wrapper_accordeons_col_droite").accordion({
              collapsible: true,
              animate: 200,
              header: '.titre_accordeon',
              heightStyle: "content",
              // active: false
          });
        },
        initInlinePadding: function(){
          //console.log('Module Executed: initInlinePadding');
          /*
          var lineSystem={};
            ET
          jQuery.fn.wraplines = function(options) {...}
            OBLIGATOIRES
            voir tout en bas.

          Copié sur :
          https://codepen.io/juhana/pen/xfmyH
          */
          $('.inlineWithPadding').wraplines();
          var opts = $('.inlineWithPadding').data();
          $('.inlineWithPadding  span').addClass('extra');
        },
        initAnimNumbers: function(){
          // console.log('Module Executed: initAnimNumbers');

          if($('.Count').length){
            var decalage = $('.CountWrapper').outerHeight();
            var start_anim = true;

            $(window).on('scroll.count-numbers', function (e) {
              // console.log('scroll.page-anim');
              if (($(window).height() + $(window).scrollTop() >= $('.CountWrapper').offset().top + decalage) && ($(window).scrollTop() <= $('.CountWrapper').offset().top + $('.CountWrapper').outerHeight()  + decalage)) {

                  console.log('inside .CountWrapper');
                  if(start_anim){
                    start_anim = false;
                    anim_big_numbers_once();
                  }
              }

            }).trigger('scroll.count-numbers');
          }

          function anim_big_numbers_once(){
            // console.log('anim_big_numbers_once');
            $('.Count').each(function () {
              var $this = $(this); // pseudo bind

              // séparer les blanc du jaune => s'il y a un 0 en premier, le sortir de la balise .Count
              if($this.attr('data-initialnumber').charAt(0) == '0'){
                console.log($this.parent().parent().find('.titre_gros_chiffre_cc').text());
                var new_text = $this.text().substring(1,$this.text().length);
                $this.text(new_text);
                $this.parent().prepend('0');
              }

              // durée animation en fonction de la taille de la string
              var initial_duration = 900;
              var final_duration = initial_duration * ($this.text().length * 2);

              // jQuery({ Counter: 0 }).animate({ Counter: $this.text() }, {
              jQuery({ Counter: 0 }).animate({ Counter: $this.attr('data-initialnumber') }, {
                duration: final_duration,
                easing: 'swing',
                step: function () {
                  $this.text(Math.ceil(this.Counter));
                }
              });

              $(window).off('scroll.count-numbers');
            });
          }


        },
        initSelect2: function () {
            //console.log('Module Executed: initSelect2');
            var svgBlanc = '<span class="icon-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="4"><path d="M1.074 0l4 4 4-4" stroke="#FFF" fill="none" fill-rule="evenodd"/></svg></span>'
            var svgVert = '<span class="icon-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="4"><path d="M1.074 0l4 4 4-4" stroke="#3e443f" fill="none" fill-rule="evenodd"/></svg></span>'
            $('.select-custom.select-custom-blanc').select2({
                minimumResultsForSearch: Infinity,
                containerCssClass: 'select-custom-container select-custom-container-blanc',
                dropdownCssClass: 'select-custom-dropdown'
            });
            $('.select-custom.select-custom-blanc-no-border').select2({
                minimumResultsForSearch: Infinity,
                containerCssClass: 'select-custom-container select-custom-container-blanc no-border',
                dropdownCssClass: 'select-custom-dropdown'
            });
            $('.select-custom.select-custom-vert-kaki').select2({
                minimumResultsForSearch: Infinity,
                containerCssClass: 'select-custom-container select-custom-container-vert-kaki',
                dropdownCssClass: 'select-custom-dropdown'
            });
            $('.select-custom.select-custom-black').select2({
                minimumResultsForSearch: Infinity,
                containerCssClass: 'select-custom-container select-custom-container-black',
                dropdownCssClass: 'select-custom-dropdown'
            });
            $('.select-custom.select-custom-produit').select2({
                minimumResultsForSearch: Infinity,
                containerCssClass: 'select-custom-container select-custom-container-produit',
                dropdownCssClass: 'select-custom-dropdown'
            });

            
            $('.select-custom.select-custom-blanc').each(function (id, ele) {
                const select2 = $(ele).parent().find('.select2');
                $(select2).find('.select2-selection').addClass('select-custom-container select-custom-container-blanc');
            });

            $('.select-custom.select-custom-blanc-no-border').each(function (id, ele) {
                const select2 = $(ele).parent().find('.select2');
                $(select2).find('.select2-selection').addClass('select-custom-container select-custom-container-blanc no-border');
            });

            $('.select-custom.select-custom-vert-kaki').each(function (id, ele) {
                const select2 = $(ele).parent().find('.select2');
                $(select2).find('.select2-selection').addClass('select-custom-container select-custom-container-vert-kaki');
            });

            $('.select-custom.select-custom-black').each(function (id, ele) {
                const select2 = $(ele).parent().find('.select2');
                $(select2).find('.select2-selection').addClass('select-custom-container select-custom-container-black');
            });

            $('.select-custom.select-custom-produit').each(function (id, ele) {
                const select2 = $(ele).parent().find('.select2');
                $(select2).find('.select2-selection').addClass('select-custom-container select-custom-container-produit');
            });
            
            
            $('.select-custom-container-blanc').append(svgBlanc);
            $('.select-custom-container-vert-kaki').append(svgVert);
            $('.select-custom-container-black').append(svgVert);
            $('.select-custom-container-produit').append(svgVert);

        },
        init2clicksBlocPoly: function() {
          // console.log('init2clicksBlocPoly');

          if( $('.TwoClicksBlocPoly').length>0 && window.matchMedia("(max-width: 768px)").matches ){

            $('.TwoClicksBlocPoly .cartouche').click(function(){
              $('.TwoClicksBlocPoly .cartouche').removeClass('hover');
              $(this).addClass('hover');
              return false;
            });

            $('.TwoClicksBlocPoly .pseudo_cta').click(function(){
              var target = $(this).closest('.cartouche').attr('href');
              window.location = target;
              return false;
            });

          }

        },
        initWooFunctions: function () {
            // Espace Compte - Mes adresses
            // Soumission des 2 formulaires billing/shipping
            $('.woocommerce .edit_address button[type="submit"]').click(function () {
                $('.woocommerce .edit_address form').each(function (id, ele) {
                    var current_form = $(ele);
                    $.ajax({
                        url: woocommerce_params.ajax_url,
                        dataType: "json",
                        type: "post",
                        data: {
                            action: 'woocommerce_edit_address_forms',
                            postdata: $(current_form).serialize(),
                            'woocommerce-edit-address-nonce': $(ele).find('input[name="woocommerce-edit-address-nonce"]').val()
                        },
                        success: function (data) {
                            if (!$(data.msg).hasClass('woocommerce-message')) {
                                $(current_form).parent().find('.woocommerce-notices-wrapper-custom').hide();
                                $(current_form).parent().find('.woocommerce-notices-wrapper-custom').html('');
                                $(current_form).parent().find('.woocommerce-notices-wrapper-custom').html(data.msg);
                                $(current_form).parent().find('.woocommerce-notices-wrapper-custom').slideDown(300);
                            } else {
                                $(current_form).parent().find('.woocommerce-notices-wrapper-custom').slideUp(300);
                            }
                            /*
                            // Si le formulaire n'a pas retourné d'erreur, on cache le message après X secondes
                            if ($(data.msg).hasClass('woocommerce-message')) {
                               setTimeout(function() {
                                $(current_form).parent().find('.woocommerce-notices-wrapper-custom').slideUp(300).html('').show()
                               },2000);}*/
                        }
                    });

                });

                return false;
            });

            // Switch produit sur select "Existe aussi en"
            $('.woocommerce .allselect select').change(function () {
                location.href = $(this).val();
            });

            // Désactive les variations indisponibles sur le select "Tailles"
            setTimeout(function () {
                $(".tabletaille select option:contains('indisponible')").attr("disabled", true);
                $(".tabletaille select option:contains('Choisir une option')").attr("disabled", true);
            }, 500);

            // Supprime l'option "Choisir une option" lors de la sélection d'une taille
            $('select[name="attribute_pa_taille"]').change(function () {
                $(".tabletaille select option:contains('Choisir une option')").remove();
            });


            // Lorsque le mini-cart est MAJ
            $(document.body).on('removed_from_cart', function () {
                // Maj des totaux dans le mini-cart

                $.ajax({
                    url: woocommerce_params.ajax_url,
                    type: "get",
                    data: {
                        action: 'woocommerce_get_cart_content_count'
                    },
                    success: function (data) {
                        $('.menu-item-cart .cart-items-count.count').html(data);
                        $('.dropdown-menu-mini-cart .end').html(' ' + data + ' article(s)');
                    }
                });
            });

            // CHeckbox Acceptation CGV
            /*$('input[name="cgv_accept"]').click(function() {

                if ($(this).is(':checked')) $('.checkout-button.button.wc-forward').removeClass('inactif');
                else $('.checkout-button.button.wc-forward').addClass('inactif');
            });*/


        }
    }
    ;

    /** [3] */
    $doc.ready(function () {
        //console.log('Initial Document Ready');

        $.readyFn.execute();
    });

    /** [4] */
    $.fn.ready = $.readyFn.register;

})
($);

/** [5] */
$(function () {

    function do_magic() {
        console.log('magic !!');
    }

    $(window).scroll(function () {

    });

    $(window).resize(function () {

    });

    //init Global
    app.initCarousel();
    app.initBugIE();
    app.initVideoPlayer();
    app.initPlayVideoEmbed();
    app.initBurgerMenu();
    // app.initTabs();
    app.initAccordion();
    app.initInlinePadding();
    app.initWooFunctions();
    app.initAnchor();
    app.initSelect();
    //app.initFiltersSticky();
    //app.initPopinConnexion();
    app.initMenuTopScroll();
    app.initStickyTimeline();
    app.initAnimNumbers();
    app.initSelect2();
    app.init2clicksBlocPoly();


    /** RESPONSIVE **/

    if (window.matchMedia("(max-width: 1024px)").matches) {
        // console.log('matchMedia UNDER 1024');

        // OUVERTURE DES SUBMENUS + désactivation des liens des sous-menus dans la version smartphone
        var items_with_sub_menu = $('.item_menu_level1 a[href="#"]');
        var items_sub_menu = $('.sub-menu-head');

        items_with_sub_menu.click(function () {
            // var id_item = $(this).attr('id') != undefined ? $(this).attr('id') : 'AUCUNE ID';
            // console.log('click on .menu_item_level1, id : ' + id_item);

            // la class .sub-menu a été ajoutée partout ou c'est nécessaire dans functions.php
            $(this).parent().find('.sub-menu').addClass('active'); // a Catalogue et Savoir faire
            $('.menus_top').addClass('level2');
            return false;
        });
        items_sub_menu.click(function () {
            $('.header_site .menus_top .item_menu_level1 .sub-menu').removeClass('active');
            $('.menus_top').removeClass('level2');
            return false;
        });


        // SLIDER ACTU
        $('.actualites_home .wrapper.actus').addClass("owl-carousel");
        $(".actualites_home .wrapper.actus.owl-carousel").owlCarousel({
            loop: false,
            margin: 0,
            items: 1,
            nav: false,
            dots: true
        });

        // SLIDER HOME
        $('.home .wrapper_slider_home .navigation_mobile select option:first-child').addClass('active');
        $('.home .wrapper_slider_home .navigation_mobile select').change(function (event) {
            $('.home .wrapper_slider_home .navigation_mobile select option').removeClass('active');
            $('.home .wrapper_slider_home .navigation_mobile select option:selected').addClass('active');
            $('.home .slider_home.owl-carousel').trigger('to.owl.carousel', $('.home .wrapper_slider_home .navigation_mobile select option:selected').attr('data-index'));
            return false;
        });
        $('.home .slider_home.owl-carousel').on('changed.owl.carousel', function (event) {
            $('.home .wrapper_slider_home .navigation_mobile select option').removeClass('active');
            var currentAnchor = $('.home .wrapper_slider_home .navigation_mobile').find("[data-index='" + event.item.index + "']");
            currentAnchor.addClass('active');
        });

    }

    if (window.matchMedia("(max-width: 480px)").matches) {
        $('.single_product .up-sells .products').addClass("owl-carousel");
        $(".single_product .up-sells .products.owl-carousel").owlCarousel({
            loop: false,
            margin: 10,
            nav: false,
            dots: true,
            items: 1,

        });
    }

    if (window.matchMedia("(max-width: 915px)").matches) {
        $('.module_raisons .raisons').addClass("owl-carousel");
        $(".module_raisons .raisons.owl-carousel").owlCarousel({
            loop: false,
            margin: 0,
            nav: false,
            dots: true,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                    nav: false,
                    dots: true,
                },
                520: {
                    items: 2,
                    nav: false,
                    dots: true,
                },
            }

        });
    }

    var a = 0;
    $(window).scroll(function () {
        if ($('.chiffre').length) {

            var oTop = $('.chiffre').offset().top - window.innerHeight;

            if (a == 0 && $(window).scrollTop() > oTop) {
                $('.chiffre').each(function () {
                    var $this = $(this),
                        countTo = $this.attr('data-number');
                    $({
                        countNum: $this.text()
                    }).animate({
                            countNum: countTo
                        },

                        {

                            duration: 2000,
                            easing: 'swing',
                            step: function () {
                                $this.text(Math.floor(this.countNum));
                            },
                            complete: function () {
                                $this.text(this.countNum);
                                //alert('finished');
                            }

                        });
                });
                a = 1;
            }
        }
    });


    /*$(window).scroll(function() {
        var height = $(window).scrollTop();

        if(height  > 500) {
           $('.chiffre').each(function () {
                $(this).prop('Counter',0).animate({
                    Counter: $(this).text()
                }, {
                    duration: 4000,
                    easing: 'swing',
                    step: function (now) {
                        $(this).text(Math.ceil(now));
                    }
                });
            });

        }
    }); */

    /*var topPos = $(this).scrollTop();
    if (topPos < 500) {
      console.log('test1');
    } else {
       console.log('test2');
    }*/


    // Barre Cookie
    setTimeout(function(){
        if (readCookie('cc_analytics') && readCookie('cc_necessary')) {$('body').addClass('cookies-set');}
        else {$('body').addClass('cookies-not-set');$('#cc-notification').slideDown(200);}
    },1500);

    $('#cc-notification a#cc-notification-moreinfo').click(function () {
        $(this).toggleClass('active');
        if ($(this).hasClass('active')) {
            $(this).text(cc_masquer_details);
            $('#cc-approve-button-thissite').text(cc_enregistrer);
        } else {
            $(this).text(cc_gerer_cookies);
            $('#cc-approve-button-thissite').text(cc_fermer);
        }

        $('#cc-notification #cc-notification-permissions').slideToggle("slow");
        return false;
    });

    $('#cc-notification a#cc-approve-button-thissite').click(function () {

        var cc_necessary,cc_analytics;

        // Création des cookies
        if ($('#cc-checkbox-necessary').is(':checked')) cc_necessary = 'yes';
        else cc_necessary = 'no';
       createCookie('cc_necessary',cc_necessary,365);

        if ($('#cc-checkbox-analytics').is(':checked')) cc_analytics = 'yes';
        else {
            cc_analytics = 'no';
            // Suppression des cookies Analytics
            eraseCookie('_ga');
            eraseCookie('_gat');
            eraseCookie('_gid');
            window['ga-disable-'+ga_ua] = true;
        }

        createCookie('cc_analytics',cc_analytics,365);

        $('#cc-notification').hide();
        $('body').removeClass('cookies-not-set').addClass('cookies-set');

        //location.reload();
        return false;
    });

});

function acceptCGV(ele) {
    if ($(ele).is(':checked')) $('.paiement-bouton.cta.wc-forward').removeClass('inactif');
    else $('.paiement-bouton.cta.wc-forward').addClass('inactif');
    $('.cgv_accept .input').toggleClass('active');
}


/*
Pour initInlinePadding => padding hyper clean autour du texte inline
*/
var lineSystem={};

jQuery.fn.wraplines = function(options) {
	var options = jQuery.extend({
		lineWrap: 'span', //name of html element used to wrap lines
		lineClassPrefix: 'wrap_line_', // prefix for class name to be added to line wrapper element
		wordClassPrefix: 'w_line_',
		index: 0,
		offsetTop: 0,
		offsetLeft: 0
	}, options);
	return this.each(function() {
		options.index  = 0;
		options.offset = 0;
		var parentElm = $(this);
		var elmText = $(parentElm).text();
		$(parentElm).html(function(ind, htm) {
			var $repText = '<' + options.lineWrap + '>' + elmText.replace( /\s/g, '</' + options.lineWrap + '> <' + options.lineWrap + '>');
			$repText = $repText + '</' + options.lineWrap + '>';
			return $repText;
		});
		$(options.lineWrap, parentElm).each(function() {
			var spanOffset = $(this).offset();
			if (spanOffset.top > options.offsetTop) {
				options.offsetTop = spanOffset.top;
				options.index++;
			}
			$(this).addClass(options.wordClassPrefix + options.index);
		});
		for (var x = 1; x <= options.index; x++) {
			$('.' + options.wordClassPrefix + x, parentElm)
			.wrapAll('<' + options.lineWrap + ' class="line ' + options.lineClassPrefix + x + '" />')
			.append(" ");
			var innerText = $('.' + options.lineClassPrefix + x, parentElm).text();
			$('.' + options.lineClassPrefix + x, parentElm).html(function() {
				return innerText;
			});
		lineSystem.index=options.index

    }
	});
};
